// Preferenze UI non sensibili (solo elenco colonne visibili nei report): nessun dato personale o credenziale.
const KEY = (name) => `nexus.report.preset.${name}`;

export const loadPreset = (name, fallback) => {
  try {
    const raw = window.localStorage.getItem(KEY(name));
    const arr = raw ? JSON.parse(raw) : null;
    return Array.isArray(arr) && arr.length ? arr : fallback;
  } catch (err) { console.warn("Preferenze report non leggibili", err); return fallback; }
};

export const savePreset = (name, fields) => {
  try { window.localStorage.setItem(KEY(name), JSON.stringify(fields)); } catch (err) { console.warn("Preferenze report non salvate", err); }
};

export const clearPreset = (name) => {
  try { window.localStorage.removeItem(KEY(name)); } catch (err) { console.warn("Preferenze report non rimosse", err); }
};

export const hasPreset = (name) => {
  try { return Boolean(window.localStorage.getItem(KEY(name))); } catch { return false; }
};
